import React from 'react';
import {useIntl} from 'react-intl';
import DownloadIcon from '../../common/components/DownloadIcon';
import {FileData} from './api';
import {CommonFile} from '../admin/documents/api';
import DocumentDownloadLink from '../../../Domains/Document/Components/DocumentDownloadLink';

interface DownloadFileProps {
    file: FileData | CommonFile;
}
const DownloadFile = ({file}: DownloadFileProps): JSX.Element => {
    const intl = useIntl();

    return (
        <DocumentDownloadLink
            file={file}
            className="cursor-pointer btn btn-link p-0 border-0"
            ariaLabel={intl.formatMessage({id: 'ADMINISTRATIVE.BILL.DOWNLOAD'})}
        >
            <DownloadIcon
                tooltip={<span>{intl.formatMessage({id: 'ADMINISTRATIVE.BILL.DOWNLOAD'})}</span>}
            />
        </DocumentDownloadLink>
    );
};

export default DownloadFile;
